import React, { useRef } from "react";
import DialogWrapper from "./DialogWrapper";
import Button from "./Button";

export default function SignIn({ closeSignIn, signInUser, openPasswordReset }) {

  const emailRef = useRef();
	const passwordRef = useRef();
	const warningRef = useRef();


	function emailChange() {
		warningRef.current.className = "";
		warningRef.current.textContent = "";
		emailRef.current.classList.remove("border-pink-500");
		emailRef.current.classList.remove("text-pink-500");
	}

	function passwordChange() {
		warningRef.current.className = "";
		warningRef.current.textContent = "";
		passwordRef.current.classList.remove("border-pink-500");
		passwordRef.current.classList.remove("text-pink-500");
	}

	function handleSubmit(e) {
		e.preventDefault();
		if (!emailRef.current.checkValidity()) {
			warningRef.current.className =
				"font-bold bg-pink-200 rounded-md border-red-500 text-red-500 p-4";
			warningRef.current.textContent = "Invalid email address";
			emailRef.current.classList.add("border-pink-500");
			emailRef.current.classList.add("text-pink-500");
			return;
		} else if (!passwordRef.current.checkValidity()) {
			warningRef.current.className =
				"font-bold bg-pink-200 rounded-md border-red-500 text-red-500 p-4";
			warningRef.current.textContent =
				"Password must be between 6 and 20 characters";
			passwordRef.current.classList.add("border-pink-500");
			passwordRef.current.classList.add("text-pink-500");
			return;
		}
		signInUser(emailRef.current.value, passwordRef.current.value);
		closeSignIn();
	}

	return (
    <DialogWrapper id='sign-in'>
        <p className="font-bold text-3xl pb-4">Sign In</p>
        <p ref={warningRef}></p>
        <form action="#">
            <label
                htmlFor="email"
                className="flex flex-col items-start gap-4 my-4 font-bold"
            >
                Email:
                <input
                    onChange={emailChange}
                    ref={emailRef}
                    className="border-2 border-slate-500 h-10 rounded-md pl-2 w-full text-slate-600
                      focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                    type="email"
                    required
                />
            </label>
            <label
                className="flex flex-col items-start gap-4 my-4 font-bold"
                htmlFor="password"
            >
                Password:
                <input
                    onChange={passwordChange}
                    ref={passwordRef}
                    className="border-2 border-slate-500 h-10 rounded-md pl-2 w-full text-slate-600
                      focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                    minLength={6}
                    maxLength={16}
                    type="password"
                    id="password"
                    required
                />
            </label>
            <Button
                color='green'
                clickFunction={handleSubmit}
                type="submit"
            >
                Sign In
            </Button>
        </form>
        <Button
            color='gray'
            clickFunction={() => {
                warningRef.current.className = "";
                warningRef.current.textContent = "";
                closeSignIn();
              }}
        >
            Cancel
        </Button>
        <p 
            className="text-slate-900 text-base font-bold"
            onClick={() => {
                openPasswordReset();
            }}
        >
            forgot your password?
        </p>
    </DialogWrapper>
	);
}
